import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

let handlingSessionExpired = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);

  const token = auth.token();
  const sedeId = auth.user?.sede_id;

  const isLoginRequest = req.url.includes('/auth/login');

  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (sedeId) headers['X-Sede-Id'] = String(sedeId);

  const authReq = Object.keys(headers).length
    ? req.clone({ setHeaders: headers })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 401 &&
        !isLoginRequest &&
        !handlingSessionExpired
      ) {
        handlingSessionExpired = true;

        auth.logout();
        toast.warning('Sesión expirada', 'Inicia sesión nuevamente para continuar.');

        router.navigate(['/login']).finally(() => {
          setTimeout(() => {
            handlingSessionExpired = false;
          }, 1000);
        });
      }

      return throwError(() => error);
    })
  );
};
